export default __webpack_public_path__ + "static/media/smartphones_bg.7ebb43bc.png";